import React from 'react';
import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import Formulario from './Sections/form';

import { Helmet } from 'react-helmet-async';
import Informativo from './Sections/informativo';

const Contatos: React.FC = () => {
    const title = 'Contatos';

    const breadcrumb = [{
        name: title,
        slug: 'contatos'
    }];

    return (
        <MainLayout>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <Header title={title} breadcrumb={breadcrumb} />
            <Informativo />
            <Formulario />
        </ MainLayout>
    );
};

export default Contatos;
